import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/*
 * Price evolution sparkline — pure SVG, no chart library.
 * Takes accepted bids ascending in time; renders a stepped premium line.
 */
export const PriceSparkline = ({ bids, height = 64, className = "" }) => {
  const { t } = useTranslation();
  const points = useMemo(() => {
    const accepted = (bids || []).filter((b) => b.amount_cents > 0);
    if (accepted.length < 2) return null;
    const values = accepted.map((b) => b.amount_cents);
    const min = Math.min(...values);
    const max = Math.max(...values);
    const span = Math.max(1, max - min);
    return values.map((v, i) => ({
      x: (i / (values.length - 1)) * 100,
      y: 90 - ((v - min) / span) * 80,
    }));
  }, [bids]);

  if (!points) return null;

  const path = points.map((p, i) => `${i === 0 ? "M" : "L"}${p.x.toFixed(2)},${p.y.toFixed(2)}`).join(" ");
  const area = `${path} L100,100 L0,100 Z`;
  const last = points[points.length - 1];

  return (
    <svg
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      style={{ height }}
      className={`w-full ${className}`}
      data-testid="price-sparkline"
      role="img"
      aria-label={t("a11y.priceEvolution")}
    >
      <path d={area} fill="rgba(29,77,59,0.08)" />
      <path d={path} fill="none" stroke="#1D4D3B" strokeWidth="1.6" vectorEffect="non-scaling-stroke" />
      <circle cx={last.x} cy={last.y} r="2.4" fill="#1D4D3B" vectorEffect="non-scaling-stroke" />
    </svg>
  );
};
